const $cache = {
    documentBody: $("html, body")
};

/**
 *  Scroll to an element/top of the page
 * @param {Object} element - target element to scroll to
 */
const scrollAnimate = element => {
    const position = element?.length ? element.offset().top : 0;

    $("html, body").animate({
        scrollTop: position
    }, 500);

    if (!element) {
        $(".header-wrapper").focus();
    }
};

/**
 * Stop document animation on manual scroll
 */
const stopAnimationOnScroll = () => {
    $cache.documentBody.on("scroll wheel mousewheel keyup touchmove", () => {
        $cache.documentBody.stop();
    });
};

export { scrollAnimate, stopAnimationOnScroll };
